var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 9,
    viewBox: "0 0 6 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.148549 8.98209L5.83199 4.80678C6.03777 4.6552 6.03777 4.34496 5.83199 4.19457L0.148549 0.0180729C0.134571 0.00779491 0.118056 0.00163786 0.100834 0.0002841C0.0836129 -0.00106966 0.0663576 0.0024328 0.050981 0.0104033C0.0356045 0.0183738 0.0227079 0.0305009 0.01372 0.0454405C0.00473213 0.06038 4.76837e-06 0.0775484 6.1512e-05 0.0950426V0.983155C6.1512e-05 1.04355 0.0292907 1.10039 0.0772276 1.13591L4.65579 4.50008L0.0772276 7.86425C0.0292907 7.89977 6.1512e-05 7.95661 6.1512e-05 8.01701V8.90512C6.1512e-05 8.98209 0.0865817 9.02708 0.148549 8.98209Z",
    fill: "#0079BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.d516b23ac54a2f1d40513f1125dd674a.svg";
export { ForwardRef as ReactComponent };